import styled from 'styled-components';

export const TitleStyled = styled.h1`
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 32px;
  color: #004b55;
`;
